module.exports = __webpack_public_path__ + "static/media/credit-card.c0019f43.png";